import { render, staticRenderFns } from "./actionNews.vue?vue&type=template&id=ed8dedd6&"
import script from "./actionNews.vue?vue&type=script&lang=js&"
export * from "./actionNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports